module.exports = __webpack_public_path__ + "static/media/Catania.c6dd4f8f.png";